/** Build authenticated download URL for support ticket attachments (legacy + new paths). */

export function extractAttachmentFilename(storedUrl) {
  if (!storedUrl || typeof storedUrl !== 'string') return '';
  try {
    return decodeURIComponent(storedUrl.split('/').pop() || '');
  } catch {
    return storedUrl.split('/').pop() || '';
  }
}

export function supportAttachmentHref(ticketRef, storedUrl, isAdmin) {
  const fname = extractAttachmentFilename(storedUrl);
  if (!ticketRef || !fname) return '#';
  const base = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
  const encRef = encodeURIComponent(ticketRef);
  const encFn = encodeURIComponent(fname);
  if (isAdmin) {
    return `${base}/api/admin/support/tickets/${encRef}/attachments/${encFn}`;
  }
  return `${base}/api/support/tickets/${encRef}/attachments/${encFn}`;
}
